import { render } from "./ApplicationAttributes.vue?vue&type=template&id=783f2717&scoped=true"
import script from "./ApplicationAttributes.vue?vue&type=script&lang=js"
export * from "./ApplicationAttributes.vue?vue&type=script&lang=js"

import "./ApplicationAttributes.vue?vue&type=style&index=0&id=783f2717&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783f2717"]])

export default __exports__